import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardHeader, List, ListItem, ListItemText } from '@material-ui/core';
import CommentIcon from '@material-ui/icons/Comment';
import { Link } from 'react-router-dom';

const styles = {
  titleLink: { textDecoration: 'none', color: '#000' },
  card: { borderLeft: 'solid 4px #ff9800', flex: 1, marginRight: '1em', marginTop: '1em' },
  icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#ff9800' },
};

const location = { pathname: 'mediasources' };

const SourceTypeStats = ({ types = new Map(), sources = { data: [], total: 0 }, classes }) => (
  <Card className={classes.card}>
    <CommentIcon className={classes.icon} />
    <CardHeader
      title={
        <Link to={location} className={classes.titleLink}>
          Media Sources ({sources.total})
        </Link>
      }
      subtitle="Media Sources by media type"
    />
    <List>
      {sources.data.map(record => (
        <ListItem
          key={record.id}
        >
          <ListItemText
            primary={(types && types.get(record.id)) || record.id}
            secondary={record.count}
          />
        </ListItem>
      ))}
    </List>
  </Card>
);

SourceTypeStats.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SourceTypeStats);


// WEBPACK FOOTER //
// ./src/dashboard/SourceTypeStats.js